import api from "../utils/axios/axiosConfig";

const notificationsService = {
  getMy: () => api.get("/notifications/my"),
  markRead: (id) => api.put(`/notifications/mark-read/${id}`),
  markAllRead: () => api.put("/notifications/mark-all-read"),
  delete: (id) => api.delete(`/notifications/delete/${id}`),
  deleteAll: () => api.delete("/notifications/delete-all"),
};

export default notificationsService;
